import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { getDefaultAuthenticatedRoute, getNetworkMemberships } from "../../utils/authRoles";

const NetworkEntryPage = () => {
  const { user, isLoading } = useUser();

  if (isLoading) return null;

  const memberships = getNetworkMemberships(user);
  if (memberships.length === 1) {
    return <Navigate to={`/app/network/${memberships[0].network_id}`} replace />;
  }
  if (memberships.length > 1) {
    return <Navigate to="/app/network/select" replace />;
  }

  return <Navigate to={getDefaultAuthenticatedRoute(user)} replace />;
};

export default NetworkEntryPage;
